import BaseModel from './BaseModel';
import Review from './Review';
import Researcher from './Researcher';
import { ReviewMemberRole } from '@/enums';

export default class ReviewMemberInvite extends BaseModel {
  constructor(data = {}) {
    super(ReviewMemberInvite, data);
    this.id = data.id;
    this.emailAddress = data.emailAddress;
    this.review = data.review ? new Review(data.review) : null;
    this.invitedBy = data.invitedBy
      ? new Researcher(data.invitedBy)
      : null;
    this.memberRole = data.memberRole || ReviewMemberRole.VIEWER;
  }
}
